import React from "react";
import styled from "styled-components";

const Img = styled.img`
  width: 25px;
`;

export default props => <Img {...props} />;
